import { render, staticRenderFns } from "./VariantSifterAssociationsPlot.vue?vue&type=template&id=36d96aab&scoped=true&"
import script from "./VariantSifterAssociationsPlot.vue?vue&type=script&lang=js&"
export * from "./VariantSifterAssociationsPlot.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterAssociationsPlot.vue?vue&type=style&index=0&id=36d96aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d96aab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d96aab')) {
      api.createRecord('36d96aab', component.options)
    } else {
      api.reload('36d96aab', component.options)
    }
    module.hot.accept("./VariantSifterAssociationsPlot.vue?vue&type=template&id=36d96aab&scoped=true&", function () {
      api.rerender('36d96aab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterAssociationsPlot.vue"
export default component.exports